import React, { useMemo } from 'react';
import { ChevronLeft, ChevronRight, Calendar as CalendarIcon } from 'lucide-react';

interface DateCarouselProps {
  selectedDate: string; // YYYY-MM-DD
  onSelectDate: (date: string) => void;
}

export const DateCarousel: React.FC<DateCarouselProps> = ({ selectedDate, onSelectDate }) => {
  const dates = useMemo(() => {
    const list = [];
    let current = new Date(selectedDate + 'T12:00:00Z');
    if (isNaN(current.getTime())) {
      current = new Date();
      current.setUTCHours(12, 0, 0, 0);
    }
    for (let i = -3; i <= 3; i++) {
      const d = new Date(current);
      d.setDate(current.getDate() + i);
      list.push(d);
    }
    return list;
  }, [selectedDate]);

  const formatDateString = (d: Date) => {
    return d.toISOString().split('T')[0];
  };

  const getDayName = (d: Date) => {
    const days = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];
    return days[d.getDay()];
  };

  const getMonthDate = (d: Date) => {
    const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
    return `${months[d.getMonth()]} ${d.getDate()}`;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
      <button style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '8px' }} onClick={() => {
        const d = new Date(selectedDate + 'T12:00:00Z');
        d.setDate(d.getDate() - 1);
        onSelectDate(formatDateString(d));
      }}>
        <ChevronLeft size={20} />
      </button>

      <div style={{ display: 'flex', flex: 1, justifyContent: 'space-around', overflowX: 'auto', gap: '8px' }}>
        {dates.map((d) => {
          const dateStr = formatDateString(d);
          const isSelected = dateStr === selectedDate;
          return (
            <div 
              key={dateStr} 
              onClick={() => onSelectDate(dateStr)}
              style={{ 
                display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer',
                padding: '8px 16px',
                borderBottom: isSelected ? '2px solid #ef4444' : '2px solid transparent',
                opacity: isSelected ? 1 : 0.6,
                minWidth: '60px'
              }}
            >
              <span style={{ fontSize: '12px', fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? 'white' : '#94a3b8' }}>
                {getDayName(d)}
              </span>
              <span style={{ fontSize: '11px', color: '#94a3b8', marginTop: '4px' }}>
                {getMonthDate(d)}
              </span>
            </div>
          );
        })}
      </div>

      <button style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '8px' }} onClick={() => {
        const d = new Date(selectedDate + 'T12:00:00Z');
        d.setDate(d.getDate() + 1);
        onSelectDate(formatDateString(d));
      }}>
        <ChevronRight size={20} />
      </button>

      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <button style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', padding: '8px', marginLeft: '8px' }}>
          <CalendarIcon size={20} />
        </button>
        <input 
          type="date"
          value={selectedDate}
          onChange={(e) => onSelectDate(e.target.value)}
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }}
        />
      </div>
    </div>
  );
};
